import { makeStyles } from "@mui/styles";

export const useInputFieldStyles = makeStyles({
  default: {
    background: "#FFFFFF",
    minWidth: "250px",
    borderRadius: "8px",
    fontFamily: "Lato",
    fontSize: "16px",
    fontWeight: 400,
  },
});
